module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.65c7b0c9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BoldItalic.woff
// module id = 520
// module chunks = 0